enum BillingsTaxiOrderListingViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default BillingsTaxiOrderListingViewMode;
